import { useState } from 'react';

import { ResultStatus } from './constants';
import { EmailView } from './email-view';
import { ErrorView } from './error-view';
import { LoadingView } from './loading-view';
import { SuccessView } from './success-view';
import { useComponentImpression } from './use-component-impression';

export function ResultsStep() {
  const [status, setStatus] = useState<ResultStatus>('idle');
  useComponentImpression(`subsidy-calculator-result-view-${status}`);

  const MIN_LOADING_TIME_MS = 5000;

  if (status === 'idle') {
    return (
      <EmailView minLoadingTime={MIN_LOADING_TIME_MS} setStatus={setStatus} />
    );
  }

  if (status === 'loading') {
    return <LoadingView minLoadingTime={MIN_LOADING_TIME_MS} />;
  }

  if (status === 'success') {
    return <SuccessView />;
  }

  if (status === 'error') {
    return <ErrorView />;
  }
}
